import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config/AppConfig";
const TermsAndConditions = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/get_all_content_url?content_type=2`
        );

        // ✅ Extract HTML string
        const htmlString = res.data || "";
        

        // ✅ Parse and extract only <body> content
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const bodyContent = doc.body?.innerHTML || htmlString;

        setContent(bodyContent);
      } catch (err) {
        console.error("Error fetching Terms & Conditions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-5">
        <h5>Loading Terms & Conditions...</h5>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <div className="container my-5">
        <div className="bg-white rounded shadow-sm p-4 p-md-5">
          <h1
            className="mb-4 pb-3"
            style={{
              borderBottom: "3px solid #ff6b35",
              fontSize: "36px",
            }}
          >
            Terms & Conditions
          </h1>

          {/* ✅ Safely render only <body> content */}
          <div
            className="text-justify"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
